<ng-container *transloco="let transl">
  <nav class="border-default bg-neutral-primary-soft fixed top-0 right-0 left-0 z-50 border-b px-2 py-3 md:px-4">
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-start">
        <button
          class="rounded-base text-body hover:bg-neutral-tertiary-medium hover:text-heading focus:ring-neutral-quaternary-medium mr-2 cursor-pointer p-2 focus:ring-2 md:hidden"
          (click)="sidebarToggle.emit()">
          <svg inert class="h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              clip-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              fill-rule="evenodd"></path>
          </svg>
          <span class="sr-only">Toggle sidebar</span>
        </button>
        <a [attr.href]="" (click)="openSite()" class="mr-4 flex min-w-[130px] items-center justify-between">
          <span class="text-heading self-center text-xl font-semibold whitespace-nowrap">Admin</span>
        </a>
      </div>
      <div class="flex items-center lg:order-2">
        <button
          type="button"
          class="rounded-base text-body hover:bg-neutral-tertiary-medium hover:text-heading focus:ring-neutral-quaternary-medium p-1.5 focus:ring-2">
          <span class="sr-only">View notifications</span>

          <svg
            class="h-6 w-6"
            inert
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path
              d="M17.133 12.632v-1.8a5.407 5.407 0 0 0-4.154-5.262.955.955 0 0 0 .021-.106V3.1a1 1 0 0 0-2 0v2.364a.933.933 0 0 0 .021.106 5.406 5.406 0 0 0-4.154 5.262v1.8C6.867 15.018 5 15.614 5 16.807 5 17.4 5 18 5.538 18h12.924C19 18 19 17.4 19 16.807c0-1.193-1.867-1.789-1.867-4.175Zm-13.267-.8a1 1 0 0 1-1-1 9.424 9.424 0 0 1 2.517-6.391A1.001 1.001 0 1 1 6.854 5.8a7.43 7.43 0 0 0-1.988 5.037 1 1 0 0 1-1 .995Zm16.268 0a1 1 0 0 1-1-1A7.431 7.431 0 0 0 17.146 5.8a1 1 0 0 1 1.471-1.354 9.424 9.424 0 0 1 2.517 6.391 1 1 0 0 1-1 .995ZM8.823 19a3.453 3.453 0 0 0 6.354 0H8.823Z" />
          </svg>
        </button>

        <button
          [cdkMenuTriggerFor]="menu"
          class="focus:ring-neutral-quaternary-medium mx-3 flex min-w-fit rounded-full text-sm focus:ring-4 md:mr-0"
          type="button">
          <span class="sr-only">Open user menu</span>
          <media-preview
            [src]="activeAccount()?.photo"
            [spinner]="false"
            class="h-10 w-10 overflow-hidden rounded-full">
            <ng-template #default>
              <default-avatar></default-avatar>
            </ng-template>
          </media-preview>
        </button>
        <!-- Dropdown menu -->
        <ng-template #menu>
          <div
            class="divide-default-medium rounded-base border-default-medium bg-neutral-primary-medium z-10 m-2 w-72 divide-y border shadow-lg"
            cdkMenu>
            <div class="text-body p-2 text-sm font-medium">
              <div class="bg-neutral-secondary-strong mb-2 flex items-center space-x-1.5 rounded p-2 px-2.5 text-sm">
                <media-preview
                  [src]="activeAccount()?.photo"
                  [spinner]="false"
                  class="h-8 w-8 overflow-hidden rounded-full">
                  <ng-template #default>
                    <default-avatar></default-avatar>
                  </ng-template>
                </media-preview>
                <div class="text-sm">
                  <div class="text-heading font-medium">{{ activeAccount()?.firstName }}</div>
                  <div class="text-body truncate">{{ identity()?.email }}</div>
                </div>
              </div>
              <button
                cdkMenuItem
                routerLink="#"
                class="hover:bg-neutral-tertiary-medium hover:text-heading inline-flex w-full items-center rounded p-2">
                <svg
                  class="me-1.5 h-4 w-4"
                  inert
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke="currentColor"
                    stroke-width="2"
                    d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
                Account
              </button>
              <button
                cdkMenuItem
                routerLink="#"
                class="hover:bg-neutral-tertiary-medium hover:text-heading inline-flex w-full items-center rounded p-2">
                <svg
                  class="me-1.5 h-4 w-4"
                  inert
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-width="2"
                    d="M20 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6h-2m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4" />
                </svg>
                Settings
              </button>
            </div>
            <div class="text-body p-2 text-sm font-medium">
              <button
                cdkMenuItem
                class="text-fg-danger hover:bg-neutral-tertiary-medium inline-flex w-full items-center rounded p-2"
                (click)="logout()">
                <svg
                  class="me-1.5 h-4 w-4"
                  inert
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" />
                </svg>
                Sign out
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </nav>
</ng-container>
